import apiClient from './apiClient';
import {
  BalanceResponse,
  BalanceHistoryResponse,
} from '../types/balance.types';

export const balanceApi = {
  /**
   * Get user's three-counter balance
   */
  getBalance: async (): Promise<BalanceResponse> => {
    const response = await apiClient.get<BalanceResponse>('/v1/balance/');
    return response.data;
  },

  /**
   * Get usage history for balance types
   */
  getHistory: async (
    balanceType?: 'searches' | 'dm_unlocks' | 'email_verifications',
  ): Promise<BalanceHistoryResponse> => {
    const params: any = {};
    if (balanceType) {
      params.balance_type = balanceType;
    }
    const response = await apiClient.get<BalanceHistoryResponse>(
      '/v1/balance/history',
      { params }
    );
    return response.data;
  },
};
